import { observer } from 'mobx-react-lite'
import { BlazeFontLoaderProps } from './Types'
import { useRootStore } from 'stores/RootStore'
import { useEffect, useRef } from 'react'
import { useIntersectionObserver } from 'hooks/useIntersectionObserver'

const BlazeFontLoader = observer(({ name, ...rest }: BlazeFontLoaderProps) => {
  const { blazeFonts } = useRootStore()
  const blazeFontsIsReady = blazeFonts.ready
  const elementRef = useRef<HTMLDivElement>(null)
  const intersection = useIntersectionObserver(elementRef, { threshold: [0, 0.5], ...rest })
  const isVisible = (intersection?.intersectionRatio ?? 0) >= 0.5

  useEffect(() => {
    if (isVisible && blazeFontsIsReady) {
      blazeFonts.load(name)
    }
  }, [isVisible, blazeFontsIsReady]) // eslint-disable-line react-hooks/exhaustive-deps

  return <div ref={elementRef} />
})

export { BlazeFontLoader }
